import React from "react";
import SEO from '../components/seo';
import Layout from "../components/layout";
import FormSection from "../components/common/templates/form/form-section";
import ImageSalesmate from "../images/Salesmate-image.png";
import ImageCB from "../images/cb-image.jpg";
import ImagePO from "../images/po-cs-work-image.jpg";
import ImagePOD from "../images/pod-image.jpg";
import ImageFlexPrint from "../images/FlexPrint-image.png";
import ImageHT from "../images/HT-image.png";
import ImageUSRetailGiant from "../images/USRetailGiant-image.png";
import { Link } from 'gatsby';
import StickyCTA from "../components/common/templates/sticky-cta-section";

const WorkPage = ({ location }) => (
    <Layout addBodyClass="work-page transparent-header" footerFormType="basic">
        <SEO description="Let’s engage into strategic and technology partnerships to re-envision your business goals. Contact us now on +1-704-208-4338 to discuss your ideas."
            meta={[{ name: "charSet", content: "utf-8" }]}
            title="Our Work - Digital Product Development" />
        <div className="work-landing-page">
            <div className="container">
                <div className="section-gap-small title-bar">
                    <h1>Recent Work</h1>
                    <p className="sub-title">We are constantly shipping software that transform and push our clients forward. </p>
                </div>

                <div className="work-grid section-gap-large">
                    <div className="row d-flex flex-wrap">
                        <div className="col mobile-hide">
                            <div className="work-grid-item">
                                <div className="work-grid-item-image ht-img"><Link to="/work/harris-teeter-online-grocery-shopping/">
                                    <img src={ImageHT} title="Omnichannel Retail Experience" alt="omnichannel retail platform" />
                                </Link></div>
                                <h3><Link to="/work/harris-teeter-online-grocery-shopping/">Omnichannel eCommerce Platform</Link></h3>
                                <p>Transforming online grocery shopping</p>
                                <span className="tagline">TRANSFORMATION   <em>|</em>   API   <em>|</em>   ENGINEERING</span>
                            </div>
                            <div className="work-grid-item">
                                <div className="work-grid-item-image flexprint-img"><Link to="/work/transforming-managed-printing-with-iot-flexprint/">
                                    <img src={ImageFlexPrint} title="Internet of things" alt="iot" />
                                </Link></div>
                                <h3><Link to="/work/transforming-managed-printing-with-iot-flexprint/">ERP Integration & Modernization</Link></h3>
                                <p>Transforming managed - printing with digital & IoT</p>
                                <span className="tagline">IOT   <em>|</em>   TRANSFORMATION   <em>|</em>   INTEGRATION</span>
                            </div>
                            
                            <div className="work-grid-item">
                                <div className="work-grid-item-image pod-img"><Link to="/work/last-mile-automation/">
                                    <img src={ImagePOD} title="last-mile-automation" alt="last-mile-automation" />
                                </Link></div>
                                <h3><Link to="/work/last-mile-automation/">Last Mile Automation</Link></h3>
                                <p>Reinventing last mile delivery</p>
                                <span className="tagline">Digital design   <em>|</em>   CLOUD   <em>|</em>   INNOVATION</span>
                            </div>
                            <div className="work-grid-item">
                                <div className="work-grid-item-image cb-img">
                                    <Link to="/work/digital-transformation-manufacturing/">
                                        <img src={ImageCB} title="digital transformation in manufacturing" alt="digital transformation in manufacturing" />
                                    </Link>
                                </div>
                                <h3><Link to="/work/digital-transformation-manufacturing/">Digital Transformation</Link></h3>
                                <p>Enabling digital evolution in manufacturing</p>
                                <span className="tagline">TRANSFORMATION   <em>|</em>   DEVOPS   <em>|</em>   CLOUD</span>
                            </div>
                        </div>
                        <div className="col mobile-hide">
                            <div className="work-grid-item">
                                <div className="work-grid-item-image kroger-img"><Link to="/work/personalized-automated-patient-experience/">
                                    <img src={ImagePO} alt="Patient experience app" title="Patient experience app" />
                                </Link></div>
                                <h3><Link to="/work/personalized-automated-patient-experience/">Automated Patient Engagement</Link></h3>
                                <p>Delivering personalized patient care experience</p>
                                <span className="tagline">ENGINEERING   <em>|</em>   ANALYTICS   <em>|</em>   CLOUD</span>
                            </div>
                            <div className="work-grid-item">
                                <div className="work-grid-item-image salesmate-img">
                                    <Link to="/work/salesmate-sales-crm/">
                                        <img src={ImageSalesmate} title="Salesmate CRM Dashboard" alt="crm dashboard" />
                                    </Link>
                                </div>
                                <h3><Link to="/work/salesmate-sales-crm/">Customer Data Platform</Link></h3>
                                <p>Building the world’s best sales operating system</p>
                                <span className="tagline">DEVOPS   <em>|</em>   ENGINEERING  <em>|</em>   ANALYTICS</span>
                            </div>
                            <div className="work-grid-item">
                                <div className="work-grid-item-image kroger-img"><Link to="/work/voice-assistant-grocery-shopping/">
                                    <img src={ImageUSRetailGiant} alt="online voice shopping experience" title="Voice Shopping Platform" />
                                </Link></div>
                                <h3><Link to="/work/voice-assistant-grocery-shopping/">Voice-enabled Shopping Assistant</Link></h3>
                                <p>Delivering hands-free retail experience</p>
                                <span className="tagline">INNOVATION   <em>|</em>   ANALYTICS   <em>|</em>   API</span>
                            </div>
                        </div>
                        <div className="col mobile-show">
                            <div className="work-grid-item">
                                <div className="work-grid-item-image ht-img"><Link to="/work/harris-teeter-online-grocery-shopping/">
                                    <img src={ImageHT} title="Omnichannel Retail Experience" alt="omnichannel retail platform" />
                                </Link></div>
                                <h3><Link to="/work/harris-teeter-online-grocery-shopping/">Omnichannel eCommerce Platform</Link></h3>
                                <p>Transforming online grocery shopping</p>
                                <span className="tagline">TRANSFORMATION   <em>|</em>   API   <em>|</em>   ENGINEERING</span>
                            </div>
                            <div className="work-grid-item">
                                <div className="work-grid-item-image kroger-img"><Link to="/work/personalized-automated-patient-experience/">
                                    <img src={ImagePO} alt="Patient experience app" title="Patient experience app" />
                                </Link></div>
                                <h3><Link to="/work/personalized-automated-patient-experience/">Automated Patient Engagement</Link></h3>
                                <p>Delivering personalized patient care experience</p>
                                <span className="tagline">ENGINEERING   <em>|</em>   ANALYTICS   <em>|</em>   CLOUD</span>
                            </div>
                            <div className="work-grid-item">
                                <div className="work-grid-item-image flexprint-img"><Link to="/work/transforming-managed-printing-with-iot-flexprint/">
                                    <img src={ImageFlexPrint} title="Internet of things" alt="iot" />
                                </Link></div>
                                <h3><Link to="/work/transforming-managed-printing-with-iot-flexprint/">ERP Integration & Modernization</Link></h3>
                                <p>Transforming managed - printing with digital & IoT</p>
                                <span className="tagline">IOT   <em>|</em>   TRANSFORMATION   <em>|</em>   INTEGRATION</span>
                            </div>
                            <div className="work-grid-item">
                                <div className="work-grid-item-image salesmate-img">
                                    <Link to="/work/salesmate-sales-crm/">
                                        <img src={ImageSalesmate} title="Salesmate CRM Dashboard" alt="crm dashboard" />
                                    </Link>
                                </div>
                                <h3><Link to="/work/salesmate-sales-crm/">Customer Data Platform</Link></h3>
                                <p>Building the world’s best sales operating system</p>
                                <span className="tagline">DEVOPS   <em>|</em>   ENGINEERING  <em>|</em>   ANALYTICS</span>
                            </div>
                            <div className="work-grid-item">
                                <div className="work-grid-item-image pod-img"><Link to="/work/last-mile-automation/">
                                    <img src={ImagePOD} title="last-mile-automation" alt="last-mile-automation" />
                                </Link></div>
                                <h3><Link to="/work/last-mile-automation/">Last Mile Automation</Link></h3>
                                <p>Reinventing last mile delivery</p>
                                <span className="tagline">Digital design   <em>|</em>   CLOUD   <em>|</em>   INNOVATION</span>
                            </div>
                            <div className="work-grid-item">
                                <div className="work-grid-item-image kroger-img"><Link to="/work/kroger-grocery-shopping-voice-assistant/">
                                    <img src={ImageUSRetailGiant} alt="online voice shopping experience" title="Voice Shopping Platform" />
                                </Link></div>
                                <h3><Link to="/work/kroger-grocery-shopping-voice-assistant/">Voice-enabled Shopping Assistant</Link></h3>
                                <p>Delivering hands-free retail experience</p>
                                <span className="tagline">INNOVATION   <em>|</em>   ANALYTICS   <em>|</em>   API</span>
                            </div>
                            <div className="work-grid-item">
                                <div className="work-grid-item-image cb-img">
                                    <Link to="/work/digital-transformation-manufacturing/">
                                        <img src={ImageCB} title="digital transformation in manufacturing" alt="digital transformation in manufacturing" />
                                    </Link>
                                </div>
                                <h3><Link to="/work/digital-transformation-manufacturing/">Digital Transformation</Link></h3>
                                <p>Enabling digital evolution in manufacturing</p>
                                <span className="tagline">TRANSFORMATION   <em>|</em>   DEVOPS   <em>|</em>   CLOUD</span>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <FormSection location={location} className="site-footer-form" id="form-section" /> */}

        {/* <StickyCTA /> */}
    </Layout>
);

export default WorkPage;
